import {
  get as getCookie,
  set as setCookie,
  remove as removeCookie,
} from "../js/utils/cookie/cookie";
import { COOKIES } from "../js/constants";

export default class MaterialForm {
  /**
   * Creates a tracking instance that handles form events in material form.
   */
  constructor() {
    this.config = {
      selectors: {
        materialForm: ".Tracking--materialForm",
      },
      attributes: {
        formName: "data-form-name",
      },
    };

    this.materialForm = document.querySelector(
      this.config.selectors.materialForm
    );

    this.materialFormId = this.materialForm?.getAttribute("id");

    this._onFirstInput = this._onFirstInput.bind(this);

    if (this.materialForm) {
      this._bindFormEvents();
    }

    this._bindCookies();
  }

  /**
   * binds material form events
   *
   * @private
   */
  _bindFormEvents() {
    this.materialForm.addEventListener("input", this._onFirstInput, {
      once: true,
    });
  }

  /**
   * handles the first material form input no matter what form field it was
   * and pushes data to dataLayer
   *
   * @private
   */
  _onFirstInput() {
    const materialStart = getCookie(COOKIES.MATERIAL_START);

    if (!materialStart) {
      const formName = this.materialForm.getAttribute(
        this.config.attributes.formName
      );

      window.dataLayer.push({
        event: "Event",
        event_name: "bestellformular_start",
        bestellformular_start: {
          bestellformular_name: formName,

          pp_event_category: "bestellformular",
          pp_event_action: formName,
          pp_event_name: "step 1 - start",

          form_goal: "Other",
          form_plugin: "Drupal",
          form_id: this.materialFormId,
        },
      });

      setCookie(COOKIES.MATERIAL_START, 1, {
        path: "/",
        end: 60 * 15,
        SameSite: "Lax",
        secure: true,
      });
    }
  }

  /**
   * binds cookies with material checkout information
   * some information from previous pages have been stored to cookies
   *
   * @private
   */
  _bindCookies() {
    const verification = getCookie(COOKIES.MATERIAL_VERIFICATION);
    const purchase = getCookie(COOKIES.MATERIAL_PURCHASE);

    if (verification) {
      this._onVerification(JSON.parse(verification));
    }

    if (purchase) {
      MaterialForm._onPurchase(JSON.parse(purchase));
    }
  }

  /**
   * handles successful verification in material form
   * pushes data to dataLayer and removes cookie
   * happens on "checkout" page
   *
   * @param {object} data
   * @private
   */
  _onVerification(data) {
    window.dataLayer.push({
      event: "Event",
      event_name: "bestellformular_review",
      bestellformular_review: {
        bestellformular_name: data.form_name,

        pp_event_category: "bestellformular",
        pp_event_action: data.form_name,
        pp_event_name: "step 2 - review",

        form_goal: "Other",
        form_plugin: "Drupal",
        form_id: this.materialFormId,
      },
    });

    removeCookie(COOKIES.MATERIAL_VERIFICATION, { path: "/" });
  }

  /**
   * handles successful purchase in material form
   * pushes data to dataLayer and removes cookie
   * happens on "Thank you" page
   *
   * @param {object} data
   * @private
   * @static
   */
  static _onPurchase(data) {
    const selectedMaterials = data.selected_materials;

    // Prepare data for the dataLayer push
    const dataLayerPushData = {
      event: "Event",
      event_name: "bestellformular_submit",
      bestellformular_submit: {
        bestellformular_name: data.form_name,

        pp_event_category: "bestellformular",
        pp_event_action: data.form_name,
        pp_event_name: "step 3 - submit",

        form_goal: "Other",
        form_plugin: "Drupal",
        form_id: data.form_id,
        form_contains_newsletter_subscription:
          data.form_contains_newsletter_subscription || false,
        form_contains_address_field: data.form_contains_address_field || false,
        form_contains_phone_field: data.form_contains_phone_field || false,
        phone_field_provided: data.phone_field_provided || false,
        newsletter_subscribed: data.newsletter_subscribed || false,
      },
    };

    // Add selected_materials only if it is defined and contains at least one item
    if (selectedMaterials && selectedMaterials.length > 0) {
      dataLayerPushData.bestellformular_submit.selected_materials =
        selectedMaterials;
    }

    window.dataLayer.push(dataLayerPushData);

    removeCookie(COOKIES.MATERIAL_START, { path: "/" });
    removeCookie(COOKIES.MATERIAL_PURCHASE, { path: "/" });
  }
}
